import {
    FETCH_ACCOUNT_USERS,
    FETCH_ACCOUNT_USERS_FAILURE,
    FETCH_ACCOUNT_USERS_SUCCESS,
} from 'store/actions/types';

export const fetchAccountUsers = (payload) => {
    return {
        type: FETCH_ACCOUNT_USERS,
        payload: payload,
    };
};

export const fetchAccountUsersFailure = (error) => {
    return {
        type: FETCH_ACCOUNT_USERS_FAILURE,
        error: error,
    };
};

export const fetchAccountUsersSuccess = (payload) => {
    return {
        type: FETCH_ACCOUNT_USERS_SUCCESS,
        payload: payload,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/accounts/users/fetchAccountUsers.js